import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Moon, Activity, Mail, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Email de réinitialisation envoyé');
    } catch (err) {
      toast.error("Erreur lors de l'envoi");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="flex items-center text-[#0596DE]">
            <Moon className="w-8 h-8" />
            <Activity className="w-8 h-8 -ml-2" />
          </div>
          <span className="font-bold text-2xl text-[#0596DE] font-['Outfit']">Tabbibak.dz</span>
        </Link>

        <div className="bg-white rounded-2xl border border-[#E2E8F0] p-8">
          {sent ? (
            <div className="text-center" data-testid="reset-sent-message">
              <div className="w-16 h-16 bg-[#D1FAE5] rounded-full flex items-center justify-center mx-auto mb-4">
                <Mail className="w-8 h-8 text-[#10B981]" />
              </div>
              <h1 className="text-2xl font-bold text-[#0F172A] font-['Outfit'] mb-2">Email envoyé</h1>
              <p className="text-[#64748B] mb-6">
                Si un compte existe avec cet email, vous recevrez un lien de réinitialisation.
              </p>
              <Link to="/login">
                <Button variant="outline" className="rounded-full">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour à la connexion
                </Button>
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-[#0F172A] font-['Outfit'] text-center mb-2">
                Mot de passe oublié ?
              </h1>
              <p className="text-[#64748B] text-center mb-8">
                Entrez votre email pour recevoir un lien de réinitialisation
              </p>

              <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
                <div>
                  <Label htmlFor="email">Email</Label>
                  <div className="relative mt-1">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#64748B]" />
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="votre@email.com"
                      className="pl-10 rounded-xl"
                      required
                      data-testid="forgot-email-input"
                    />
                  </div>
                </div>

                <Button
                  type="submit"
                  className="w-full rounded-full bg-[#0596DE] hover:bg-[#047CBA] h-12"
                  disabled={loading}
                  data-testid="forgot-submit-btn"
                >
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                </Button>
              </form>

              <p className="text-center text-[#64748B] mt-6">
                <Link to="/login" className="text-[#0596DE] hover:underline font-medium">
                  <ArrowLeft className="w-4 h-4 inline mr-1" />
                  Retour à la connexion
                </Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
